import React, { useContext } from 'react';
import classes from './MediaImageFromLink.module.scss';
import loaderClasses from '../../../components/containers/Loader/Loader.module.scss';
import mediaBlockClasses from '../MediaBlock/MediaBlock.module.scss';

import { BoxNotification } from '../../../components/containers/BoxNotification';
import { BeaconContext } from '../../../providers/BeaconProvider';
import { SelectedImagesFromLinkType } from './MediaImageFromLink.controller';
import { MediaItemFromLink } from './MediaItemFromLink';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import pluralize from 'pluralize';
import classNames from 'classnames';

export type MediaImageFromLinkViewProps = {
  //
  loading: boolean;
  imageUrls: string[];
  selectHandler: (index: number, e: React.MouseEvent<HTMLInputElement>) => void;
  selectedImages: SelectedImagesFromLinkType[];
  addImagesHandler: VoidFunction;
};

export const MediaImageFromLinkView = (props: MediaImageFromLinkViewProps): JSX.Element => {
  const { loading, imageUrls, selectHandler, selectedImages, addImagesHandler } = props;
  const { beacon } = useContext(BeaconContext);
  const selectedIndexes = selectedImages.map(item => item.index);
  const loaderWrapperClasses = classNames(loaderClasses.LoaderWrapperSmall, loaderClasses.LoaderWrapper);
  const spinnerClasses = classNames(loaderClasses.Spinner, loaderClasses.SpinnerSmall, loaderClasses.SpinnerDark);

  return (
    <>
      <div className={'margin-top-small-24 margin-bottom-small-24'}>
        <h6>OR CHOOSE IMAGES FROM YOUR ATTACHED LINK</h6>
      </div>
      {loading ? (
        <BoxNotification type={'info'}>
          <span className={'grid-x grid-padding-x align-middle'}>
            <span className={'cell shrink'}>
              <span className={loaderWrapperClasses}>
                <span className={spinnerClasses}>
                  <span className={'show-for-sr'}>Loading...</span>
                </span>
              </span>
            </span>
            <span className={'cell auto'}>Fetching images from the attached link...</span>
          </span>
        </BoxNotification>
      ) : imageUrls.length ? (
        <div className={mediaBlockClasses.MediaBlock}>
          <div className={classes.MediaItemsWrapper}>
            {imageUrls.map((url, index) => {
              return (
                <MediaItemFromLink
                  key={index}
                  index={index}
                  loading={loading}
                  url={url}
                  checked={selectedIndexes.includes(index)}
                  selectHandler={selectHandler}
                />
              );
            })}
          </div>
        </div>
      ) : (
        <BoxNotification type={'warning'}>
          <p className={classes.NoImagesText}>
            We were unable to find any images from your attached link.{' '}
            <a
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                beacon('article', '685', { type: 'modal' });
              }}>
              Learn more
            </a>
            .
          </p>
        </BoxNotification>
      )}
      <div className={'grid-x align-right'}>
        <div className={'cell shrink margin-top-small-24'}>
          <Button
            action={e => {
              e.stopPropagation();
              addImagesHandler();
            }}
            type={'button'}
            variant={'solid'}
            size={'large'}
            color={ButtonColorsEnum.secondary}
            disabled={loading || !selectedIndexes.length}>
            {`Add ${pluralize('Image', selectedIndexes.length, !!selectedIndexes.length)} To Post`}
          </Button>
        </div>
      </div>
    </>
  );
};
